var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowMarkInfluencerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.079,
    viewBox: "0 0 20 19.079",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "influencer",
    transform: "translate(0 -11.795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28061",
    "data-name": "Group 28061",
    transform: "translate(0 11.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18371",
    "data-name": "Path 18371",
    d: "M19.971,19.04a.586.586,0,0,0-.473-.4l-6.2-.9-2.773-5.618a.586.586,0,0,0-1.051,0L6.7,17.74l-6.2.9a.586.586,0,0,0-.325,1l4.486,4.373L3.6,30.189a.586.586,0,0,0,.578.685H15.818a.586.586,0,0,0,.577-.685l-1.059-6.175,4.486-4.373A.586.586,0,0,0,19.971,19.04ZM10,18.4a2.469,2.469,0,1,1-2.469,2.469A2.472,2.472,0,0,1,10,18.4ZM5.688,29.7a4.352,4.352,0,0,1,8.624,0Z",
    transform: "translate(0 -11.795)",
    fill: "#deaa0c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowMarkInfluencerIcon);
export default __webpack_public_path__ + "static/media/yellow_mark_Influencer_icon.fa30c4d22947f57a566929ff40cc4e7c.svg";
export { ForwardRef as ReactComponent };